$(document).ready(function() {
    $('.page_nav').on('click', function() {
        $.smoothScroll({
            offset: -50,
            speed: 1400,
            scrollTarget: this.hash
        });

        return false;
    });

    $('.chevron-up').on('click', function(e) {
        e.preventDefault();
        var pos = {};
        var allElements = $('.page, footer');
        var viewCoords = $(window).scrollTop();

        $.each(allElements, function(i, val) {
            if(val.offsetTop > viewCoords)
            {
                if(i > 0)
                {
                    i = parseInt(i - 1);
                }
                pos = allElements[i].id;
                return false;
            }
        });

        $.smoothScroll({
            offset: -50,
            speed: 1400,
            scrollTarget: '#' + pos
        });

    });

    $('.chevron-down').on('click', function(e) {
        e.preventDefault();
        var pos = {};
        var allElements = $('.page, footer');
        var viewCoords = $(window).scrollTop();

        $.each(allElements, function(i, val) {
            if(val.offsetTop > viewCoords)
            {
                pos = allElements[i].id;
                if(typeof allElements[i + 1] === 'object')
                {
                    pos = allElements[i + 1].id;
                }

                return false;
            }
        });

        $.smoothScroll({
            offset: -50,
            speed: 1400,
            scrollTarget: '#' + pos
        });

    });

    $('#myCarousel').carousel({
        interval:   4000
    });



    $('#booking').hide();
    $('#b').on('click', function(e) {

        $(e.target).fadeToggle(500);
        setTimeout(function() {
            if(e.target.innerHTML == 'Switch to Booking')
            {
                e.target.innerHTML = 'Switch to Contact';
            }
            else
            {
                e.target.innerHTML = 'Switch to Booking';
            }
        }, 1100 );
        $(e.target).fadeToggle(2000);
        $('#contact').slideToggle(1000);
        $('#booking').fadeToggle(1000);
    });

    $('.selectBox').on('click', function(e) {

        var placeholder = 'Placeholder';

        if($('.selectBox').hasClass('active'))
        {
            $('.options ul li').each(function() {
                //console.log(e.target.parentElement);
                if($(this).hasClass('selected'))
                {
                    $(this).removeClass('selected');
                }
            });

            if($(e.target.parentElement).context.nodeName == 'LI')
            {
                $(e.target.parentElement).addClass('selected');
                $('[data-id="placeholder"]').html($(e.target.parentElement).context.textContent);
                $('#' + $('.options').data('target')).val($(e.target.parentElement).context.dataset.value);
            }

        }
        else
        {
            $('[data-id="placeholder"]').html(placeholder);
        }
        $('.selectBox').toggleClass('active');

    });
});